import React from "react";

const TermsOfService = () => (
  <div style={{ maxWidth: 800, margin: "2rem auto", padding: "2rem" }}>
    <h1>Terms of Service</h1>
    <p>Last updated: October 15, 2025</p>
    <p>
      Welcome to IonianFarsi (<a href="https://ionianfarsi.gr">ionianfarsi.gr</a>). By using our website and services, you agree to these Terms of Service. Please read them carefully.
    </p>
    <h2>1. Acceptance of Terms</h2>
    <p>
      By accessing or using IonianFarsi, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, please do not use our services.
    </p>
    <h2>2. User Accounts</h2>
    <ul>
      <li>You must provide accurate information when creating an account.</li>
      <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
      <li>You must be at least 13 years old to use IonianFarsi.</li>
      <li>We reserve the right to suspend or terminate accounts for violations of these Terms or for suspicious activity.</li>
    </ul>
    <h2>3. Acceptable Use</h2>
    <ul>
      <li>Do not use IonianFarsi for any unlawful, harmful, or abusive purpose.</li>
      <li>Do not attempt to access accounts or data that do not belong to you.</li>
      <li>Do not upload or share content that is offensive, illegal, or violates intellectual property rights.</li>
    </ul>
    <h2>4. Intellectual Property</h2>
    <p>
      All content, trademarks, and software on IonianFarsi are owned by us or our licensors. You may not copy, modify, or distribute any part of our service without permission.
    </p>
    <h2>5. Service Availability</h2>
    <p>
      We strive to keep IonianFarsi available, but we do not guarantee uninterrupted service. We may change, suspend, or discontinue any part of the service at any time without notice.
    </p>
    <h2>6. Limitation of Liability</h2>
    <p>
      IonianFarsi is provided "as is" without warranties of any kind. We are not liable for any damages resulting from your use of the service, including loss of data or interruption of service.
    </p>
    <h2>7. Indemnification</h2>
    <p>
      You agree to indemnify and hold harmless IonianFarsi and its team from any claims, damages, or expenses arising from your use of the service or violation of these Terms.
    </p>
    <h2>8. Changes to Terms</h2>
    <p>
      We may update these Terms from time to time. Changes will be posted on this page. Continued use of IonianFarsi after changes means you accept the new Terms.
    </p>
    <h2>9. Governing Law</h2>
    <p>
      These Terms are governed by the laws of Greece. Any disputes will be resolved in the courts of Greece.
    </p>
    <h2>10. Contact</h2>
    <p>
      For questions about these Terms, contact us at <a href="mailto:inf2022001@ionio.gr">inf2022001@ionio.gr</a>.
    </p>
  </div>
);

export default TermsOfService;
